module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/chair-2-8824e481c84ec72ad4042352eb4331f9.svg";